import { Input } from 'antd';
import React from 'react';

const Nombres = ({ disabled = false,value='',onChange }) => {
    return (
        <div>
             <Input variant='underlined' type='number'
            placeholder="Nombre"
            disabled={disabled}
            style={{ width: '40%', }}
             value={value}
             onChange={e => onChange(e.target.value)}
            />
        </div>
    );
};

export default Nombres;